/* eslint-disable */
/**
 * Create styles for `<placeOrderPage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<placeOrderPage />` styles
 */
const placeOrderPageStyles = ({ theme }) => ({
  paper: {},
  root: {},
  sidebarRoot: {},
});

export default placeOrderPageStyles;
